import React, { useState, useEffect } from "react";
import EmailIcon from "../../assets/images/email-icon.svg";
import "antd/dist/antd.css";
import "../../css/users.css";
import LeftSideNav from "../../components/LeftSideNav";
function VerifyUser() {
  const [input, setInput] = useState({
    secretKey: "",
  });
  const timerInsecond = 30;
  const [seconds, setSeconds] = useState(timerInsecond);

  const [otp, setOpt] = useState("");

  const [email, setemail] = useState("");
  const [path, setpath] = useState("");

  const handleResendCode = async (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
  };

  const handleSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {};

  const waitingSecView = () => (
    <div className="main-right-div">
      <div className="verify-form-div">
        <img alt="email icon" src={EmailIcon} className="email-icon" />
        <h2>Verify your email</h2>
        <div className="verify-form-message">
          <h4>You will need to verify your email to complete registration</h4>
        </div>
        <p>
          An email has been sent to you with link to verify your account
          <br />
          If you have not received the email after few minutes,please check your
          spam folder.
        </p>

        <div className="resend-code">
          <h5>
            {/* Didn't receive the code?{" "} */}
            {seconds > 0 ? (
              <span style={{ color: "blue" }}>
                {/* Please wait 00:{seconds.zeroPad()} */}
              </span>
            ) : (
              <a href="" onClick={handleResendCode}>
                Resend Email
              </a>
            )}
          </h5>
        </div>
      </div>
    </div>
  );

  return (
    <div className="login_container">
      <div className="left-nav-col">
        <LeftSideNav />
      </div>
      <div className="verify_email_container">{waitingSecView()}</div>
    </div>
  );
}

export default VerifyUser;
